// extracted by mini-css-extract-plugin
export var orderDetails = "_rf-2";
export var orderImage = "_rf-1";
export var orderMeta = "_rf-3";
export var orderSummary = "_rf-0";
export var rightArrow = "_rf-4";